/* eslint-disable no-console */
import { useZustandStore } from 'hooks/useZustandStore';
import { featureFlagClient } from 'utils';
import { zustandDialogStore } from '../../zustandStores/dialogStore';
import type { IDialog, TDialogKey } from './DialogStore.types';

export const useDialogStore = () => {
  const dialogStoreRefactorJson = featureFlagClient.getJSON(
    'dialogStoreRefactorFeature',
  );

  const { dialogs, setDialogs } = useZustandStore(
    zustandDialogStore,
    store => ({
      dialogs: store.dialogs,
      setDialogs: store.setDialogs,
    }),
  );

  const addDialog = (dialog: IDialog) => {
    if (keyExists(dialog.key)) {
      console.warn(`Duplicate key: ${dialog.key} found in dialogStore`);
    }

    const newDialogs = [dialog, ...dialogs];
    setDialogs(newDialogs);
  };

  const removeDialog = (key: TDialogKey) => {
    if (!keyExists) {
      console.warn(`Key: ${key} does not exist in dialogStore`);
    }

    const newDialogs = dialogs.filter(dialog => dialog.key !== key);
    setDialogs(newDialogs);
  };

  const removeAllDialogs = () => {
    setDialogs([]);
  };

  const isUsingNewArchitecture = (key: TDialogKey) =>
    dialogStoreRefactorJson.enabled &&
    dialogStoreRefactorJson.enabledDialogs?.includes(key);

  const keyExists = (key: TDialogKey) =>
    !!dialogs.find(dialog => dialog.key === key);

  return {
    dialogs,
    addDialog,
    removeDialog,
    removeAllDialogs,
    isDialogVisible: keyExists,
    isUsingNewArchitecture,
  };
};
